<template>
  <h3>Mis gastos de saldo</h3>

  <div class="controlls">
    <a-form class="form" layout="vertical" :model="formState">
      <a-form-item>
        <ChannelIdMultiPicker
          v-model:value="formState.channel_customers"
          :channelType="ChannelType.WhatsappVoice"
        />
      </a-form-item>

      <a-form-item>
        <!-- TODO: (observaciones beex) Cambiar linea :disabled-date="disabledDateRage && disabledDateRule" por :disabled-date="disabledDateRage" -->
        <a-range-picker
          v-model:value="formState.dateRange"
          format="DD/MM/YYYY"
          valueFormat="YYYY-MM-DD"
          :disabled-date="disabledDateRage && disabledDateRule"
          @calendarChange="handleCalendarChange"
        />
      </a-form-item>
    </a-form>

    <a-button :loading="downloading" @click="handleDownload"
      >Descargar gastos <DownloadOutlined
    /></a-button>
  </div>

  <a-table
    size="middle"
    id="expenses-table"
    :scroll="scrollStyle"
    :loading="loading"
    :columns="whatsappVoiceExpensesColumns"
    :dataSource="expensesCurrentPage"
    :pagination="false"
    @change="handleTableChange"
  >
    <template #headerCell="{ title, column }">
      <template v-if="column.type === 'info'">
        {{ title }}

        <a-tooltip :title="column.info">
          <InfoCircleOutlined />
        </a-tooltip>
      </template>
    </template>

    <template #bodyCell="{ column, record, text, index }">
      <template v-if="column.dataIndex === 'date'">
        {{ dateTimeToSlashFormat(text, false) }}
      </template>

      <template v-if="index === tableSource.length - 1 && column.dataIndex === 'date'">
        <div ref="observerFlagRef" />
      </template>
    </template>

    <template #summary>
      <a-table-summary fixed>
        <a-table-summary-row>
          <a-table-summary-cell :index="0">Total</a-table-summary-cell>

          <a-table-summary-cell :index="1"> </a-table-summary-cell>

          <a-table-summary-cell :index="2"> </a-table-summary-cell>

          <a-table-summary-cell :index="3"> </a-table-summary-cell>

          <a-table-summary-cell :index="4"> {{ secondsToTimeString(getTotalByCategory("total_minutes") * 60) }} </a-table-summary-cell>

          <a-table-summary-cell :index="5"> ${{ getTotalByCategory("total_price") }} </a-table-summary-cell>
        </a-table-summary-row>
      </a-table-summary>
    </template>
  </a-table>
</template>

<script setup>
import { ref, reactive, watch } from "vue";
import { InfoCircleOutlined, DownloadOutlined } from "@ant-design/icons-vue";
import { useIntersectionObserver } from "@vueuse/core";
import _ from "lodash";
import dayjs from "dayjs";

import { whatsappVoiceExpensesColumns } from "@/app/settings/utils/columns";
import { fetchWhatsappVoiceExpenses, downloadWhatsappVoiceExpenses } from "@/app/settings/services";
import { useScrollResize } from "@/app/shared/composables/useScrollResize";
import { dateTimeToSlashFormat, secondsToTimeString } from "@/app/shared/utils/dates";
import { ChannelType } from "@/app/shared/utils/enums";
import { downloadFile } from "@/app/shared/utils/file";
import { useDateRangeLimit } from "@/app/shared/composables/useDateRangeLimit";

import ChannelIdMultiPicker from "@/app/shared/components/pickers/ChannelIdMultiPicker.vue";

const { scrollStyle } = useScrollResize({ headerMargin: 525, width: 1100 });

const emit = defineEmits(["loading"]);

const observerFlagRef = ref(null);

// TODO: (observaciones beex) Eliminar (observaciones beex)
const disabledDateRule = (current) => {
  const workspace = localStorage.getItem("workspace");
  if (workspace != "culqi") return current && current < new Date(2024, 7, 1);
  return false;
};

const { pause, resume } = useIntersectionObserver(observerFlagRef, ([{ isIntersecting }]) => {
  console.log({ isIntersecting });
  if (isIntersecting && expensesCurrentPage.value.next) {
    currentTablePage.value++;
    fetchExpensesTableData({ resetFilters: false });
  }
});

const todayDate = dayjs().format("YYYY-MM-DD");

const formState = reactive({
  billing_category: "",
  dateRange: [todayDate, todayDate],
  channel_customers: [],
});
const expensesCurrentPage = ref([]);

const loading = ref(false);
const currentTablePage = ref(1);

const tableSource = ref([]);
// const totalExpenses = ref(null);

const { handleCalendarChange, disabledDateRage } = useDateRangeLimit(31);

const getTotalByCategory = (key) => {
  const categoryData = expensesCurrentPage.value.map((record) => record[key]);

  const totalSum = categoryData.reduce((prev, curr) => prev + curr, 0);

  return Number(totalSum.toFixed(4));
};

const fetchExpensesTableData = async ({ resetFilters = true } = {}) => {
  if (resetFilters) loading.value = true;

  if (!resetFilters) pause();

  const filters = _.cloneDeep(formState);

  if (!filters.dateRange || filters.dateRange.length < 2) {
    expensesCurrentPage.value = [];
    loading.value = false;
    return;
  }
  
  filters.dateRange[1] = `${filters.dateRange[1]} 23:59:59`;

  emit('loading', true);
  try {
    expensesCurrentPage.value = await fetchWhatsappVoiceExpenses({
      filters: filters,
      page: currentTablePage.value,
    });
  }
  finally {
    emit('loading', false);
  }

  // totalExpenses.value = await fetchTotalExpenses({ filters: filters });

  // if (resetFilters) tableSource.value = [];

  // tableSource.value.push(...expensesCurrentPage.value.results);
  //
  // if (!resetFilters) resume();
  //
  loading.value = false;
};

// const disabledDate = (current) => {
//   const limit = dayjs("2023-06-30");
//
//   return current && current < limit.endOf("day");
// };

const downloading = ref(false);

const handleDownload = async () => {
  downloading.value = true;

  try {
    const filters = _.cloneDeep(formState);
    filters.dateRange[1] = `${filters.dateRange[1]} 23:59:59`;

    const response = await downloadWhatsappVoiceExpenses({ filters });

    downloadFile(response, "expenses.xlsx", { useResponseFileName: true });
  } catch (error) {
    console.error(error);
  }

  downloading.value = false;
};

watch(
  formState,
  _.debounce(() => {
    currentTablePage.value = 1;
    fetchExpensesTableData();
  }, 500),
  { immediate: true }
);

defineExpose({ fetchExpensesTableData });
</script>

<style lang="sass" scoped>
.controlls
  margin-bottom: 12px
  display: flex
  align-items: center
  justify-content: space-between

.form
  display: flex
  gap: 12px

  .input
    min-width: 160px

:deep(.ant-form-item)
  margin: 0

#expenses-table tfoot th,
#expenses-table tfoot td
  background-color: #fafafa !important
</style>
